import { render, staticRenderFns } from "./OfferOnesignal.vue?vue&type=template&id=577d998a&"
import script from "./OfferOnesignal.vue?vue&type=script&lang=js&"
export * from "./OfferOnesignal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports